import { delegate } from 'tippy.js'

// Не создаём по инстансу Tippy на каждую плитку/иконку при загрузке
// Инстанс появляется лениво, когда пользователь впервые взаимодействует с конкретным элементом
// Позиция: по умолчанию — top, если атрибут пустой
delegate(document.body, {
  target: '[data-tooltip-text]',
  theme: 'tooltip',
  animation: 'fade',
  maxWidth: 320,
  arrow: true,
  placement: 'top',
  appendTo: () => document.body,
  popperOptions: {
    modifiers: [
      {
        name: 'flip',
        options: { fallbackPlacements: ['top', 'bottom', 'left', 'right'] }
      },
      { name: 'preventOverflow', options: { padding: 8 } }
    ]
  },
  onShow(instance) {
    // узел, на котором висит подсказка (тот, что совпал с [data-tooltip-text])
    const el = instance.reference
    const icon = el.getAttribute('data-tooltip-icon')
    const text = el.getAttribute('data-tooltip-text')
    const pos = (el.getAttribute('data-tooltip-position') || '').trim()

    let content

    if (icon) {
      const div = document.createElement('div')
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      const use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
      const textEl = document.createElement('p')

      div.className = 'tippy-icon'
      svg.setAttribute('width', '1em')
      svg.setAttribute('height', '1em')
      svg.setAttribute('fill', 'none')
      svg.dataset.icon = `icon-${icon}`
      use.setAttribute('href', `#icon-${icon}`)
      textEl.className = 'tippy__text'
      textEl.textContent = text

      svg.append(use)
      div.append(svg, textEl)
      content = div
    } else {
      content = text
    }

    instance.setContent(content)
    instance.setProps({
      placement: pos || 'top'
    })
  }
})
